export default {"src":"/_next/static/media/draw-icon.8ae4dfa1.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};